module.exports = __webpack_public_path__ + "front/img/btn.b7f0c8c0.jpg";